"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
// locals
var configuration_1 = require("../configuration");
// ui elements
var Logo_1 = require("./Logo");
var Logo = (0, mobx_react_1.observer)(function (_ref) {
  var session = _ref.session;
  var configuration = session.configuration;
  var logoPath = (0, configuration_1.readConfObject)(configuration, 'logoPath');
  if (!(logoPath === null || logoPath === void 0 ? void 0 : logoPath.uri)) {
    return react_1.default.createElement(Logo_1.LogoFull, {
      variant: "white"
    });
  } else {
    return react_1.default.createElement("img", {
      src: logoPath.uri,
      alt: "Custom logo"
    });
  }
});
exports.default = Logo;